export { default, type BadgeProps } from './badge';
